import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export interface CardProps {
    className?: string;
    children: ReactNode;
    onClick?: () => void;
}

export const Card = ({ className, children, onClick }: CardProps) => {
    const handleKeyDown = (event: React.KeyboardEvent) => {
        if (onClick && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            onClick();
        }
    };

    return (
        <div
            className={clsx('overflow-hidden rounded-lg', className)}
            onClick={onClick}
            onKeyDown={onClick ? handleKeyDown : undefined}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            {children}
        </div>
    );
};

export default Card;
